import { Component, Input, OnInit } from '@angular/core';
import {
  FundConstituentData
} from '../../../../shared/models/etf';
@Component({
  selector: 'app-etf-constituent',
  templateUrl: './etf-constituent.component.html',
  styleUrls: ['./etf-constituent.component.scss']
})
export class EtfConstituentComponent implements OnInit{
isMobile: boolean = false;
ngOnInit(): void {
  this.isMobile = window.innerWidth <= 768;
}
    addThousandsSeparator(numStr: string): string {
     // 先將字串轉換成數字
     const num = parseFloat(numStr);

     // 如果不是有效的數字，直接返回原字串
     if (isNaN(num)) {
         return numStr;
     }

      // 將數字轉換成千分位格式的字串，並保留原始的小數位數
     return num.toLocaleString(undefined, { minimumFractionDigits: numStr.split('.')[1]?.length });
    }

  @Input() data: FundConstituentData = {} as FundConstituentData;

  // Item2 區塊
  shownCountItem2: number = 10;
  showMoreItem2(): void {
    const total = this.data?.Item2?.length || 0;
    this.shownCountItem2 = Math.min(this.shownCountItem2 + 10, total);
  }

  // Item3 區塊
  shownCountItem3: number = 10;
  showMoreItem3(): void {
    const total = this.data?.Item3?.length || 0;
    this.shownCountItem3 = Math.min(this.shownCountItem3 + 10, total);
  }

  // 動態表格
  shownCounts: number[] = [];

  ngOnChanges(): void {
    if (this.data?.Tables && this.shownCounts.length === 0) {
      this.shownCounts = this.data.Tables.map(() => 10); // 每張表初始顯示10筆
    }
  }

  showMoreTable(index: number): void {
    const total = this.data.Tables[index]?.RowDetails?.length || 0;
    this.shownCounts[index] = Math.min(this.shownCounts[index] + 10, total);
  }
}
